import React from "react";
import code from "./img/codingcourse.png";
import skills from "./img/homeskills.png";
import "./css/Courses.css";
import market from "./img/marketing.png";

function Courses() {
  return (
    <div className="courses">
      <div className="courses-content">
        <p>Top Categories</p>
      </div>
      <div className="courses-content-cards">
        <div className="courses-cards">
          <div className="courses-card">
            <div className="courses-card-img">
              <img src={code} alt="coding" />
            </div>
            <div className="courses-desc">
              <div className="courses-desc-content">
                <p>Learn Programming</p>
                <div className="courses-desc-content-curri">
                  <p>
                    Learn important concepts related to coding and build
                    efficient system.
                    <br />
                    <br /> We provide you a lots of tutorial absolutely free.
                    So, you can start building your dream project sooner and be
                    a tech buddy while in college.
                  </p>
                </div>
                <button>Explore More</button>
              </div>
            </div>
          </div>
          <div className="courses-card skills">
            <div className="courses-card-img">
              <img src={skills} alt="skills" />
            </div>
            <div
              style={{
                marginRight: "auto",
                marginLeft: 0,
              }}
              className="courses-desc"
            >
              <div className="courses-desc-content">
                <p>Learn Soft Skills</p>
                <div className="courses-desc-content-curri">
                  <p>
                    Soft skills are similar to emotions or insights that allow
                    people to “read” others. These are much harder to learn, at
                    least in a traditional classroom.
                    <br /> <br />
                    We provide you a platform learn soft skills absolutely free.
                    And Be a technically sound person in college.
                  </p>
                </div>
                <button>Explore More</button>
              </div>
            </div>
          </div>
          <div className="courses-card">
            <div className="courses-card-img">
              <img src={market} alt="market" />
            </div>
            <div className="courses-desc">
              <div className="courses-desc-content">
                <p>Learn Digital Marketing</p>
                <div className="courses-desc-content-curri">
                  <p>
                    Be at top in the marketing industry with digital marketing
                    skills. Learn fundamentals like SEO, Backlinks, Ads etc from
                    our customized and efficient course.
                    <br /> <br />
                    We provide live interactive classes to learn <br />
                    Digital Marketing fundamentals.
                  </p>
                </div>
                <button>Explore More</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Courses;
